import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export const percentileInTextColors = {
    VeryLow: `text-percentile-very-low`,
    Low: 'text-percentile-low',
    Medium: 'text-percentile-medium',
    High: 'text-percentile-high',
    Top: 'text-percentile-top',
};
